import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {BsModalRef,BsModalService} from "ngx-bootstrap/modal";
import { first } from 'rxjs/operators'
import { ModalChangeLocation } from './modal-change-location/modal-change-location.component';
import {AuthApiService} from "../../shared/core-jpats/services/auth.service";

@Component({
  selector: 'button-change-location',
  templateUrl: './button-change-location.component.html',
  styleUrls: ['./button-change-location.component.scss']
})
export class ButtonChangeLocationComponent implements OnInit {
  isMouse: boolean;

  bsModalRef: BsModalRef;
  constructor(private authApiService: AuthApiService, private modalService: BsModalService, private router: Router) {}

  async showModal(showWelcome: boolean = false) {
    let activeElement = document.activeElement;

    await this.router.navigate(['/jpats/']);
    this.authApiService.resetPatientSearch.emit();
    this.bsModalRef = this.modalService.show(ModalChangeLocation, { backdrop: 'static', keyboard: false });

    this.bsModalRef.onHide.pipe(first()).subscribe((param?) => {
      if (activeElement && activeElement instanceof HTMLElement) {
        //If all modals are closed, return focus to previous activeElement
        if (document.body.className.indexOf('modal-open') == -1) {
          activeElement.focus();
          if (this.isMouse) activeElement.blur();
        }
      }
    });

    this.bsModalRef.content.showWelcome = showWelcome;
  }
  ngOnInit() {
    
  }

  ngAfterViewInit() {
    
  }

  async onClick(event?) {
    this.isMouse = event ? (event.pointerType == "mouse") : false;
    await this.showModal()
  }
}
